import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=70ed3282&scoped=true&"
import script from "./UserList.vue?vue&type=script&lang=js&"
export * from "./UserList.vue?vue&type=script&lang=js&"
import style0 from "./UserList.vue?vue&type=style&index=0&id=70ed3282&prod&lang=scss&scoped=true&"
import style1 from "./UserList.vue?vue&type=style&index=1&id=70ed3282&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ed3282",
  null
  
)

export default component.exports